import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/starterDashboardV2/pageContext';

export const StarterDashboardV2ErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	/** Possible to implement custom view based on error instead of throwing */
	throw new Error(`Failed to retrieve data for StarterDashboardV2 page (error: ${error})`);
};
